import React, { useState } from "react";
import Logo from "../../Images/Header/logo.png";
import fb from "../../Images/Footer/facebook.png";
import insta from "../../Images/Footer/instagram.png";
import linkden from "../../Images/Footer/linkedin.png";
import yt from "../../Images/Footer/youtube.png";
import twitter from "../../Images/Footer/twitter.png";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "../../CSS/Footer/index.css";

const SOCIAL_LINKS = [
  { href: "#", icon: fb, label: "Facebook" },
  { href: "#", icon: twitter, label: "Twitter" },
  { href: "#", icon: insta, label: "Instagram" },
  { href: "#", icon: linkden, label: "LinkedIn" },
  { href: "#", icon: yt, label: "YouTube" },
];

function Footer() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");

  const handleNewsletterSubmit = (event) => {
    event.preventDefault();
    setEmail("");
  };

  return (
    <footer className="site-footer">
      <span className="site-footer__glow" aria-hidden="true" />
      <span className="site-footer__glow site-footer__glow--left" aria-hidden="true" />

      <div className="site-footer__container">
        <div className="site-footer__grid">
          <div className="site-footer__brand">
            <Link to="/" className="site-footer__logo-link">
              <img src={Logo} alt="Comfort Trip" />
            </Link>
            <p className="site-footer__tagline">
              Personal driver service — book rides with comfort and confidence.
            </p>
          </div>

          <div className="site-footer__col">
            <Link to="/about-us" className="site-footer__link site-footer__heading-link">
              <h6 className="site-footer__heading">{t("footer_column1_title")}</h6>
            </Link>
            <ul className="site-footer__links">
              <li>
                <Link to="/help-support" className="site-footer__link">
                  {t("footer_menu2")}
                </Link>
              </li>
              <li>
                <Link to="/contact" className="site-footer__link">
                  {t("footer_menu3")}
                </Link>
              </li>
            </ul>
          </div>

          <div className="site-footer__col">
            <h6 className="site-footer__heading">{t("footer_column2_title")}</h6>
            <ul className="site-footer__links">
              <li>
                <Link to="/privacypolicy" className="site-footer__link">
                  {t("page_title_privacy_policy")}
                </Link>
              </li>
              <li>
                <Link to="/cookies-policy" className="site-footer__link">
                  {t("page_title_cookies_policy")}
                </Link>
              </li>
              <li>
                <Link to="/terms-conditions" className="site-footer__link">
                  {t("page_title_terms_conditions")}
                </Link>
              </li>
            </ul>
          </div>

          <div className="site-footer__newsletter">
            <h6 className="site-footer__heading">{t("footer_newsletter_text")}</h6>
            <p className="site-footer__newsletter-text">
              Get updates on rides, offers, and news from Comfort Trip.
            </p>
            <form className="site-footer__form" onSubmit={handleNewsletterSubmit}>
              <div className="site-footer__input-wrap">
                <input
                  type="email"
                  className="site-footer__input"
                  placeholder={t("footer_newsletter_inputText")}
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="site-footer__submit">
                Subscribe
              </button>
            </form>
          </div>
        </div>

        <div className="site-footer__divider" />

        <div className="site-footer__bottom">
          <p className="site-footer__copyright">
            © {new Date().getFullYear()} Comfort Trip. All rights reserved.
          </p>
          <div className="site-footer__social">
            {SOCIAL_LINKS.map((social) => (
              <a
                key={social.label}
                href={social.href}
                className="site-footer__social-link"
                aria-label={social.label}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img src={social.icon} alt="" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
